(() => {
  const template = document.getElementById('TopCartLashFan');
  if (!template || template.dataset.ready) return;
  template.dataset.ready = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '[data-single-variant-quick-add], [name="add"], .js-add-to-cart, top-lash-order [data-add], [data-treatment-add], top-mobile-product [data-purchase]';
  const origins = new WeakMap();
  let forwarded;

  // Cache the visible position before the theme can open the drawer or replace its button.
  document.addEventListener('click', event => {
    const button = event.target instanceof Element && event.target.closest(selector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || reduced.matches) return;
    if (!event.isTrusted && forwarded && forwarded.target === button) {
      origins.set(button, forwarded.origin);
      return;
    }
    const rect = button.getBoundingClientRect();
    const left = Math.max(0, rect.left), right = Math.min(innerWidth, rect.right);
    const top = Math.max(0, rect.top), bottom = Math.min(innerHeight, rect.bottom);
    if (left >= right || top >= bottom) return;
    const origin = { x: (left + right) / 2, y: (top + bottom) / 2, time: performance.now() };
    const mobileBar = button.closest('top-mobile-product');
    if (mobileBar && button.hasAttribute('data-purchase')) {
      // The sticky CTA forwards its click to the product or batch-order button synchronously.
      forwarded = { target: mobileBar.target, origin };
      setTimeout(() => { forwarded = null; }, 0);
    } else {
      origins.set(button, origin);
    }
  }, { capture: true, passive: true });

  document.addEventListener('ajaxProduct:added', event => {
    const { product, addToCartBtn } = event.detail || {};
    if (!product || product.errors || Number(product.status) >= 400 || document.hidden || reduced.matches) return;
    const qtyCard = event.target instanceof Element && event.target.closest('at-add-to-cart');
    const button = addToCartBtn || (qtyCard && qtyCard.querySelector('.js-add-to-cart'));
    const origin = button && origins.get(button);
    if (!origin) return;
    origins.delete(button);
    if (performance.now() - origin.time > 30000) return;
    if (qtyCard) {
      const line = product.items?.find(item => String(item.variant_id) === qtyCard.dataset.variantId);
      if (!line || line.quantity <= Number(qtyCard.dataset.count || 0)) return;
    }

    const narrow = innerWidth < 750;
    const spread = narrow ? 49 : 76;
    const rise = narrow ? 75 : 104;
    ['#931B40', '#E5A3D0', '#111111'].forEach((color, index) => {
      const side = index - 1;
      const word = template.content.firstElementChild.cloneNode(true);
      const endX = Math.max(20, Math.min(innerWidth - 20, origin.x + side * spread));
      const dy = (origin.y < rise + 18 ? 1 : -1) * rise * (side ? .7 : 1);
      word.style.left = origin.x + 'px';
      word.style.top = origin.y + 'px';
      word.style.color = color;
      word.style.animationDelay = index * 32 + 'ms';
      word.style.setProperty('--lash-x', (endX - origin.x) + 'px');
      word.style.setProperty('--lash-y', dy + 'px');
      word.style.setProperty('--lash-tilt', (side * 32) + 'deg');
      document.body.appendChild(word);
      setTimeout(() => word.remove(), 1000);
    });

    const header = document.getElementById('HeaderCartTrigger');
    if (!header || !Element.prototype.animate) return;
    const item = qtyCard ? product.items.find(line => String(line.variant_id) === qtyCard.dataset.variantId) : (product.items?.[0] || product);
    const src = item?.featured_image?.url || item?.image;
    if (typeof src !== 'string' || !src) return;
    const photo = new Image();
    photo.alt = '';
    photo.setAttribute('aria-hidden', 'true');
    photo.style.cssText = 'position:fixed;width:54px;height:54px;object-fit:contain;padding:3px;box-sizing:border-box;background:white;border:2px solid #931b40;border-radius:50%;box-shadow:0 3px 12px #0003;pointer-events:none;z-index:2147483000';
    photo.style.left = (origin.x - 27) + 'px';
    photo.style.top = (origin.y - 27) + 'px';
    photo.onload = () => {
      if (reduced.matches || document.hidden || performance.now() - origin.time > 5000) return;
      const icon = header.querySelector('.cart-link svg') || header.querySelector('.cart-link') || header;
      const cart = icon.getBoundingClientRect();
      const x = cart.left + cart.width / 2, y = cart.top + cart.height / 2;
      document.body.appendChild(photo);
      const dx = x - origin.x, dy = y - origin.y;
      const flight = photo.animate([
        {transform:'translate(0,0) scale(1)', opacity:1},
        {transform:'translate(' + dx * .4 + 'px,' + (dy * .55 - 32) + 'px) scale(.85)', opacity:1, offset:.45},
        {transform:'translate(' + dx + 'px,' + dy + 'px) scale(.22)', opacity:1, offset:.93},
        {transform:'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity:0}
      ], {duration:1150,easing:'ease-in-out',fill:'forwards'});
      flight.onfinish = flight.oncancel = () => photo.remove();
    };
    photo.src = src;
  }, { capture: true, passive: true });
})();
